/** Fonts */
export const muli = "'Muli', Helvetica, Arial, sans-serif"
export const veraMono = "'VeraSansMono-Bold', Helvetica, Arial, sans-serif"

/** Colors */
export const black = "#000"
export const white = "#FFF"
export const yellow = "#cf8303"

export const redXXXLight = "#F1E2E2"
export const redXLight = "#C42F2E"
export const redLight = "#AA1514"
export const redMedium = "#AA1514"
export const redDark = "#910000"
export const redXDark = "#770000"
export const redXXDark = "#5E0000"

export const burntOrangeXXXLight = "#FAECE9"
export const burntOrangeXLight = "#DB6347"
export const burntOrangeLight = "#CE4828"
export const burntOrangeMedium = "#BD4225"
export const burntOrangeDark = "#A73A21"
export const burntOrangeXDark = "#9D371D"
export const burntOrangeXXDark = "#802D18"

export const corporateGreenXXXLight = "#E8F1E7"
export const corporateGreenXLight = "#63C15D"
export const corporateGreenLight = "#49A743"
export const corporateGreenMedium = "#3A8535"
export const corporateGreenDark = "#216C1C"
export const corporateGreenXDark = "#2C6428"
export const corporateGreenXXDark = "#134B0F"

export const youthPinkXXXLight = "#F7E8EF"
export const youthPinkXLight = "#FF55B6"
export const youthPinkLight = "#D33391"
export const youthPinkMedium = "#DE2283"
export const youthPinkDark = "#C5096A"
export const youthPinkXDark = "#A71962"
export const youthPinkXXDark = "#8E0049"

export const disabilityBlueXXXLight = "#e6eff6"
export const disabilityBlueXLight = "#5ab1f5"
export const disabilityBlueLight = "#4097db"
export const disabilityBlueMedium = "#247bbf"
export const disabilityBlueDark = "#0b62a6"
export const disabilityBlueXDark = "#005596"
export const disabilityBlueXXDark = "#00488c"

export const agedCareTealXXXLight = "#e5f6f6"
export const agedCareTealXLight = "#1abfc6"
export const agedCareTealLight = "#00a5ac"
export const agedCareTealMedium = "#008388"
export const agedCareTealDark = "#006a6f"
export const agedCareTealXDark = "#006266"
export const agedCareTealXXDark = "#005055"

export const greyXXXLight = "#f6f6f6"
export const greyXLight = "#e0e0e0"
export const greyLight = "#afafaf"
export const greyMedium = "#7c7c7c"
export const greyDark = "#666"
export const greyXDark = "#515050"
export const greyXXDark = "#353535"

export const IDPWDPurple = "#472871"
export const fosterCareGreen = "#338736"
export const fosterCareTypePurple = "#613F75"
export const fosterCareTypeGreenLight = "#eaf3ea"

export const successGreen = "#F1F8F1"
export const validationGreen = "#338736"
export const validationBackgroundRed = "#F1E2E2"
export const validationRed = "#B50019"
export const disabledGrey = greyLight

interface KeyValues {
  [key: string]: string
}

const map: KeyValues = {
  black,
  white,
  greyLight,
  greyMedium,
  greyDark,
  greyXDark,
  corporateGreenXXXLight,
  corporateGreenXLight,
  corporateGreenLight,
  corporateGreenMedium,
  corporateGreenDark,
  corporateGreenXDark,
  corporateGreenXXDark,
  validationGreen,
  validationRed,
  fosterCareTypePurple,
  fosterCareTypeGreenLight
}

export const colorMap = (color: string | undefined): string => {
  return color !== undefined ? map[color] : "#000"
}
